module.exports = __webpack_public_path__ + "media/images/svg/clients/4-79810deff4f511ecd7ff9161a8a8943a.svg";